<template>
  <div class="byPopModel1">
    <div class="wrapper1">
      <div class="row-item element-list">
        <div class="left-item jb-bg">仪器名称：</div>
        <div class="rigth-item text1">
          {{ formData.instrumentName }}
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">仪器设备编号：</div>
        <div class="rigth-item text1">
          {{ formData.serialNumber }}
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">型号：</div>
        <div class="rigth-item text1">
          {{ formData.pattern }}
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">保养时间：</div>
        <div class="rigth-item">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.handleTime"
            type="datetime"
            class="date-picker"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">维护内容：</div>
        <div class="rigth-item">
          <el-input  maxlength="100" v-model="formData.content"></el-input>
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">维护结论：</div>
        <div class="rigth-item">
          <el-input  maxlength="100" v-model="formData.conclusion"></el-input>
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">处理意见：</div>
        <div class="rigth-item">
          <el-input  maxlength="100" v-model="formData.manageOpinion"></el-input>
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">经手人：</div>
        <div class="rigth-item">
          <el-input maxlength="50" v-model="formData.manageUser"></el-input>
        </div>
      </div>
      <div class="row-item element-list train">
        <div class="left-item jb-bg">备注：</div>
        <div class="rigth-item">
          <el-input  maxlength="300" v-model="formData.remark"></el-input>
        </div>
      </div>
      <div class="row-item element-list">
        <div class="left-item jb-bg">状态：</div>
        <div class="rigth-item">
          <el-select
            :poper-append-to-body="false"
            v-model="formData.states"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button type="primary" class=" btn" @click="dispose(true)">确认</el-button>
      <el-button class=" btn" @click="dispose(false)">取消</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    message: Object,
    isEdit: Boolean,
  },
  computed: {
    particular() {
      return this.message;
    },
  },

  data() {
    return {
      options: [
        {
          value: 0,
          label: "正常",
        },
        {
          value: 1,
          label: "降级",
        },
        {
          value: 2,
          label: "停用",
        },
        {
          value: 3,
          label: "需维修",
        },
        {
          value: 4,
          label: "需检定",
        },
        {
          value: 5,
          label: "需保养",
        },
        {
          value: 6,
          label: "报废",
        },
      ],
      formData: {
        instrumentName: "", //仪器名称
        serialNumber: "", //仪器编号
        pattern: "", //型号
        handleTime: null, //保养时间
        content: "", //维护内容
        conclusion: "", //维护结论
        manageOpinion: "", //处理意见
        manageUser: "", //经手人
        remark: "", //备注
        states: "", //状态
        id: "", //设备id
      },
    };
  },
  mounted() {
    Object.keys(this.formData).forEach((key) => {
      if (
        key == "id" ||
        key == "states" ||
        key == "pattern" ||
        key == "instrumentName" ||
        key == "serialNumber" ||
        key == "remark" ||
        key == 'conclusion' ||
        key == 'manageOpinion' ||
        key == 'manageUser' ||
        key == 'handleTime' ||
        key == 'content'
      ) {
        this.formData[key] = this.particular[key];
      }
    });
  },
  methods: {
    dispose(item) {
      let bloVal = item;
      let data = {
        ...this.formData,
      };
      if (!this.isEdit) {
        data.instrumentId = this.formData.id
        delete data.id
      }
      if (bloVal) {
        if (data.handleTime == "" || data.handleTime == null) {
          this.$message({
            message: "请选择保养时间",
            type: "warning",
          });
          return;
        }
        if (data.content == "" || data.content == null) {
          this.$message({
            message: "请填写维护内容",
            type: "warning",
          });
          return;
        }
        if (data.conclusion == "" || data.conclusion == null) {
          this.$message({
            message: "请填写维护结论",
            type: "warning",
          });
          return;
        }
        if (data.manageOpinion == "" || data.manageOpinion == null) {
          this.$message({
            message: "请填写处理意见",
            type: "warning",
          });
          return;
        }
        if (data.manageUser == "" || data.manageUser == null) {
          this.$message({
            message: "请填写经手人",
            type: "warning",
          });
          return;
        }
      } else {
      }

      this.$emit("dispose", bloVal, data);
      // if (data.handleTime == "") {
      //   this.$message({
      //     message: "请选择保养时间",
      //     type: "warning",
      //   });
      //   return;
      // }
      // if (data.accuracy == "") {
      //   this.$message({
      //     message: "不确定度/准确度不为空",
      //     type: "warning",
      //   });
      //   return;
      // }
      // if (data.precision == "") {
      //   this.$message({
      //     message: "准确度不能空",
      //     type: "warning",
      //   });
      //   return;
      // }
      // this.$emit("dispose", bloVal, data);
    },
  },
};
</script>

<style lang="less" scoped>
.byPopModel1 {
  width: 100%;
  // height: 360px;
  // display: flex;
  // white-space: nowrap
  .wrapper1 {
    .row-item {
      margin: 16px 0px;
      display: flex;
      .list-item-btn{
        display: inline-block;
        margin: auto;
        padding: 0 20px;
        height: 28px;
        line-height: 28px;
        text-align: center;
      }
    }
  }
  .footer {
    clear: both;
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .train {
    width: 720px !important;
  }
  .element-list {
    width: 350px;
    float: left;
    /*border: 2px solid #0090f0;*/
    /*border-radius: 6px;*/
    height: 30px;
    line-height: 30px;
    margin: 10px 10px;
    text-align: center;
    .left-item {
      width: 150px;
    }
    .rigth-item {
      width: calc(100% - 150px);
      padding: 0 5px;
      box-sizing: border-box;
      text-align: left;
      /deep/ .el-upload-list {
        height: 60px;
        overflow: auto;
      }
      /deep/ .el-input__prefix {
        display: none;
      }
      /deep/ .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100%;
      }
      /deep/ .el-input__icon {
        line-height: 30px;
      }
    }
  }
  .btn {
    width: 150px;
    margin-right: 10px;
    cursor: pointer;
  }
  .text1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .jb-bg {
    /*background-image: linear-gradient(#0479b4, #02407e);*/
  }
}
.date-picker {
  /deep/.el-input__inner {
    padding: 0 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/byPopModel1.vue